RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const ChartConfiguration = Marionette.Dashboard.models.Configuration.extend({
        idAttribute: 'channel',
        urlRoot: '/api/configurations/charts'
    });

    const Analyze = RivalIQ.data.CacheLayer.extend({
        name: 'Analyze Configuration',
        Model: ChartConfiguration,
        cacheKeys: [
            'channel'
        ],

        loadData: function (attrs) {
            const me = this;
            const model = new me.Model({
                channel: attrs.channel || 'cross_channel'
            });

            return model.fetch().then(function () {
                return model;
            });
        }
    });

    data.chartConfigurations = new Analyze();

});
